import { Pipe, PipeTransform } from '@angular/core';
import _ from 'lodash';
import moment from 'moment';
import { Duration } from 'moment/moment';
import { Observable, isObservable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
   name: 'singleTimeUnit$',
})
export class SingleTimeUnitPipe implements PipeTransform {
   transform(inputValue: Duration | number | Observable<Duration> | Observable<number>): Observable<string> {
      const duration$ = isObservable(inputValue) ? inputValue : of(inputValue);

      return duration$.pipe(
         map((x) => {
            if (!_.isNumber(x)) {
               return x;
            }
            return moment.duration(x, 'ms');
         }),
         map((waitingDuration) => {
            if (waitingDuration.asMilliseconds() < 0) {
               return '';
            }
            const waitingYears = waitingDuration.years();
            const waitingMonths = waitingDuration.months();
            const waitingDays = waitingDuration.days();
            const waitingHours = waitingDuration.hours();
            const waitingMinutes = waitingDuration.minutes();

            if (waitingYears > 1) {
               return 'common.time_units.years';
            } else if (waitingYears === 1) {
               return 'common.time_units.year';
            } else if (waitingMonths > 1) {
               return 'common.time_units.months';
            } else if (waitingMonths === 1) {
               return 'common.time_units.month';
            } else if (waitingDays > 1) {
               return 'common.time_units.days';
            } else if (waitingDays === 1) {
               return 'common.time_units.day';
            } else if (waitingHours > 1) {
               return 'common.time_units.hours';
            } else if (waitingHours === 1) {
               return 'common.time_units.hour';
            } else if (waitingMinutes > 1) {
               return 'common.time_units.minutes';
            } else if (waitingMinutes === 1) {
               return 'common.time_units.minute';
            }
            return `common.time_units.seconds`;
         })
      );
   }
}
